import { render } from "./RelatorioLogs.vue?vue&type=template&id=34c8eaf0&scoped=true"
import script from "./RelatorioLogs.vue?vue&type=script&lang=js"
export * from "./RelatorioLogs.vue?vue&type=script&lang=js"

import "./RelatorioLogs.vue?vue&type=style&index=0&id=34c8eaf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c8eaf0"]])

export default __exports__